<template>
  <v-container class="my-5">
    <h2 class="subheading grey--text">Amenidades del Club</h2>

    <v-layout row wrap class="mt-4">
      <v-flex xs12 sm6 md4 v-for="amenity in amenities" :key="amenity.id" class="pa-2">
        <v-card outlined class="amenity-card">
          <v-card-title class="primary--text">{{ amenity.name }}</v-card-title>
          <v-card-text>
            <p class="mb-2">
              <v-icon small color="primary" class="mr-2">{{ amenity.icon }}</v-icon>
              <strong>Capacidad:</strong> {{ amenity.capacity }} personas
            </p>
            <p class="mb-2">
              <v-icon small color="primary" class="mr-2">mdi-clock-outline</v-icon>
              <strong>Disponible:</strong> {{ amenity.available_hours }}
            </p>
            <p>
              <strong>Estado:</strong>
              <v-chip
                  :color="amenity.status === 'Activo' ? 'green' : 'red'"
                  text-color="white"
                  x-small
              >
                {{ amenity.status }}
              </v-chip>
            </p>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" small>Reservar</v-btn>
            <v-spacer></v-spacer>
            <v-icon small color="primary" @click="amenity.expanded = !amenity.expanded">
              {{ amenity.expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
            </v-icon>
          </v-card-actions>
          <v-expand-transition>
            <div v-if="amenity.expanded">
              <v-divider></v-divider>
              <v-card-text>
                <p><strong>Descripción:</strong> {{ amenity.description }}</p>
              </v-card-text>
            </div>
          </v-expand-transition>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'ClubHouseAmenities',
  data () {
    return {
      amenities: [
        {
          id: 1,
          name: 'Restaurante',
          icon: 'mdi-silverware-fork-knife',
          capacity: 200,
          available_hours: '7:00 AM - 11:00 PM',
          status: 'Activo',
          description: 'Restaurante con servicio a la carta y buffet. Menú variado de gastronomía internacional.',
          expanded: false
        },
        {
          id: 2,
          name: 'Salón de Eventos',
          icon: 'mdi-party-popper',
          capacity: 300,
          available_hours: '10:00 AM - 10:00 PM',
          status: 'Activo',
          description: 'Salón principal con capacidad para eventos grandes, bodas y conferencias.',
          expanded: false
        },
        {
          id: 3,
          name: 'Cancha de Tenis',
          icon: 'mdi-tennis',
          capacity: 4,
          available_hours: '7:00 AM - 7:00 PM',
          status: 'Activo',
          description: 'Dos canchas de tenis profesionales con superficie de arcilla y hormigón.',
          expanded: false
        },
        {
          id: 4,
          name: 'Piscina Olímpica',
          icon: 'mdi-pool',
          capacity: 150,
          available_hours: '8:00 AM - 8:00 PM',
          status: 'Activo',
          description: 'Piscina de 50 metros con servicios de salvavidas y lecciones de natación.',
          expanded: false
        },
        {
          id: 5,
          name: 'Cancha de Golf (18 Hoyos)',
          icon: 'mdi-golf',
          capacity: 72,
          available_hours: '6:00 AM - 6:00 PM',
          status: 'Activo',
          description: 'Campo de golf profesional de 18 hoyos, Par 72, diseñado por maestros internacionales.',
          expanded: false
        },
        {
          id: 6,
          name: 'Centro Fitness',
          icon: 'mdi-dumbbell',
          capacity: 100,
          available_hours: '6:00 AM - 10:00 PM',
          status: 'Activo',
          description: 'Gimnasio completamente equipado con máquinas cardiovasculares, pesas y clases grupales.',
          expanded: false
        },
        {
          id: 7,
          name: 'Spa y Wellness',
          icon: 'mdi-spa',
          capacity: 30,
          available_hours: '9:00 AM - 9:00 PM',
          status: 'Activo',
          description: 'Centro de relajación con masajes, sauna y tratamientos de bienestar.',
          expanded: false
        },
        {
          id: 8,
          name: 'Biblioteca y Sala Lectura',
          icon: 'mdi-library-shelves',
          capacity: 50,
          available_hours: '8:00 AM - 9:00 PM',
          status: 'Activo',
          description: 'Espacio tranquilo con amplio acervo de libros y acceso a internet.',
          expanded: false
        },
        {
          id: 9,
          name: 'Cancha de Squash',
          icon: 'mdi-squash',
          capacity: 4,
          available_hours: '8:00 AM - 9:00 PM',
          status: 'Activo',
          description: 'Dos canchas profesionales con sistema de reserva online.',
          expanded: false
        }
      ]
    }
  }
}
</script>

<style scoped>
.amenity-card {
  transition: all 0.3s ease;
  height: 100%;
}

.amenity-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}
</style>
